module.exports = __webpack_public_path__ + "static/womenArtist-a6edc322390a66f5fd8ed8654be3d202.jpeg";